import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";

type LessonsReducer = {
  list: any;
};

const lessonsReducer = createSlice({
  name: "lessons",
  initialState: { list: [] } as LessonsReducer,
  reducers: {
    setLessons: (state, action: { payload: any }) => {
      state.list = action.payload;
    },
  },
});

export const { setLessons } = lessonsReducer.actions;

export const getLessons = (state: RootState) => state.lessons.list;

export default lessonsReducer.reducer;
